import { Funnel } from '../models/funnel';
import { Action } from '@ngrx/store';

export const FUNNEL_ACTION_FAIL = '[Funnel] Funnel Action Fail';
export const FUNNEL_ACTION_SUCCESS = '[Funnel] Funnel Action Success';
export const CLEAR_FUNNEL = '[Funnel] Clear Funnel';
export const FUNNEL_CLEAR_ERRORS = '[Funnel] Clear Funnel Errors';
export const LOAD_FUNNEL = '[Funnel] Load Funnel';
export const LOAD_FUNNEL_SUCCESS = '[Funnel] Load Funnel Success';

export class FunnelActionFail implements Action {
  readonly type = FUNNEL_ACTION_FAIL;

  constructor(public payload: any) {}
}

export class FunnelActionSuccess implements Action {
  readonly type = FUNNEL_ACTION_SUCCESS;

  constructor(public payload: any) {}
}

export class ClearFunnel implements Action {
  readonly type = CLEAR_FUNNEL;
}

export class FunnelClearErrors implements Action {
  readonly type = FUNNEL_CLEAR_ERRORS;
}

// FUNNEL
export class LoadFunnel implements Action {
  readonly type = LOAD_FUNNEL;

  constructor(public payload: { id: number }) {}
}

export class LoadFunnelSuccess implements Action {
  readonly type = LOAD_FUNNEL_SUCCESS;

  constructor(public payload: Funnel) {}
}

export type All =
  | FunnelActionFail
  | FunnelActionSuccess
  | ClearFunnel
  | FunnelClearErrors
  | LoadFunnel
  | LoadFunnelSuccess;
